import { Filter, X } from 'lucide-react'
import { type ReactNode } from 'react'

import { Button } from '@/components/ui/button'

/**
 * The white filter card shared by every admin table: a titled header with a
 * Filter icon and a conditional "clear" button, wrapping the field grid
 * (passed as `children`).
 */
interface TableFilterPanelProps {
  title: string
  clearLabel: string
  hasActiveFilters: boolean
  onClear: () => void
  children: ReactNode
}

export function TableFilterPanel({
  title,
  clearLabel,
  hasActiveFilters,
  onClear,
  children
}: TableFilterPanelProps) {
  return (
    <div className="rounded-2xl border border-ink/[0.06] bg-white p-5 shadow-[0_10px_30px_rgba(4,33,37,0.05)]">
      <div className="mb-4 flex items-center justify-between gap-3">
        <div className="flex items-center gap-2 font-display text-base font-bold text-ink">
          <Filter className="h-4 w-4 text-primary" />
          {title}
        </div>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClear}
            className="border-0 bg-transparent text-muted-foreground hover:bg-ink/[0.05] hover:text-ink"
          >
            <X className="h-4 w-4" />
            {clearLabel}
          </Button>
        )}
      </div>
      {children}
    </div>
  )
}
